import { createContext, createElement, useContext, type ComponentType } from 'react';
export interface PrepaidChoiceProps {
  clientId: string;
  serviceId: string;
  clientName?: string | undefined;
  date?: string | undefined;
  value: string;
  onChange: (id: string) => void;
}
const Choice = createContext<ComponentType<PrepaidChoiceProps> | null>(null);
export const SchedulingPrepaidProvider = Choice.Provider;
export function SchedulingPrepaidChoice(props: PrepaidChoiceProps) {
  const Component = useContext(Choice);
  return Component ? createElement(Component, props) : null;
}

const BalancesLink = createContext<((clientId: string) => void) | undefined>(undefined);
export const SchedulingBalancesLinkProvider = BalancesLink.Provider;
export function SchedulingBalancesLink({ clientId }: { clientId: string }) {
  const open = useContext(BalancesLink);
  return open
    ? createElement(
        'button',
        {
          type: 'button',
          className: 'text-sm font-semibold text-brand-400 hover:underline',
          onClick: () => open(clientId),
        },
        'Ver saldos e produtos do cliente',
      )
    : null;
}
